var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tinyeditor',{staticClass:"sk-tinyeditor",attrs:{"disabled":_vm.disabled,"init":_vm.init},on:{"onClick":_vm.onClick},model:{value:(_vm.tinymceHtml),callback:function ($$v) {_vm.tinymceHtml=$$v},expression:"tinymceHtml"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }